import { render, staticRenderFns } from "./actionsLinked.vue?vue&type=template&id=04ff4a1a&"
import script from "./actionsLinked.vue?vue&type=script&lang=js&"
export * from "./actionsLinked.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports